import React from 'react';
import { KeyRound } from 'lucide-react';
import GtplSaathiSettingsTab from './GtplSaathiSettingsTab';
import useDarkReady from '../theme/useDarkReady';
import { Screen, PageHead } from '../components/gtpl/GtplKit';

// Staff-delegable home for GtplSaathiSettingsTab (same component the admin Settings page's
// "GTPL Saathi" tab embeds) — the tab's content was previously reachable ONLY through
// /settings, which is hard-gated `roles={['admin']}` in App.js with no moduleKey bypass, so
// no Site Role grant could ever surface it to staff (see navConfig.js's old comment on the
// "Session & Settings" child). This page exists purely so that link can point somewhere
// staff can actually reach — same `moduleKey: 'gtplSaathi'` route gate as its 4 siblings
// (Subscriber Lookup, Multi Renew, Modify, Hardware Replacement), with the individual
// session/settings actions themselves still gated server-side (GET /session readable by the
// base 'view' right, pasting a cookie / toggling settings still requires 'manageSession').
export default function GtplSaathiSettingsPage() {
  useDarkReady();
  return (
    <Screen narrow>
      <PageHead icon={KeyRound} tone="adv" title="GTPL login and settings"
        sub="Is the login working, how to fix it, and what runs automatically." />
      <GtplSaathiSettingsTab />
    </Screen>
  );
}
